export const unauthorizedPassengers = (date?: string) => {
  return [
    { text: 'Unauthorized Passengers', style: 'h1' },

    { text: 'Federal Motor Carrier Safety Regulations Part § 392.60', fontSize: 12, bold: true, alignment: 'center', margin: [0, 0, 0, 10] },

    { text: 'Unauthorized persons not to be transported:', fontSize: 12, bold: true, alignment: 'center', margin: [0, 0, 0, 10] },

    { text: '1. Unless specifically authorized in writing to do so by the motor carrier under whose authority the commercial motor vehicle is being operated, no driver shall transport any person or permit any person to be transported on any commercial motor vehicle other than a bus. When such authorization is issued, it shall state the name of the person to be transported, the points where the transportation is to begin and end, and the date upon which such authority expires. No written authorization, however, shall be necessary for the transportation of:', style: 'p'},
    { text: '(1.1) Employees or other persons assigned to a commercial motor vehicle by a motor carrier;', style: 'p', margin: [20, 0, 0, 0]},
    { text: '(1.2) Any person transported when aid is being rendered in case of an accident or other emergency;', style: 'p', margin: [20, 0, 0, 0]},
    { text: '(1.3) An attendant delegated to care for livestock.', style: 'p', margin: [20, 0, 0, 10]},

    { text: '2. This section shall not apply to the operation of commercial motor vehicles controlled and operated by any farmer and used in the transportation of agricultural commodities or products thereof from his/her farm or in the transportation of supplies to his/her farm.', style: 'p'},

    { text: 'This certifies that I am familiar with the above mentioned qualifications specified in the U.S. Department of Transportation Federal Motor Carrier Safety Administration Manual.', style: 'p', bold: true, alignment: 'center' },

    {
      canvas: [
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 200,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        {
          type: 'line',
          x1: 500,
          y1: 0,
          x2: 350,
          y2: 0,
          lineWidth: 1, 
          lineColor: 'black',
        },
      ],
      style: 'input',
      margin: [0, 40, 0, 0]
    },

    { text: "Driver's Signature", style: 'label', margin: [0, 2, 0, 0] },
    { text: `${date}`, margin: [350, -32, 0, 0] },
    { text: "Date", style: 'label', margin: [350, 5, 0, 0] },

    { text: '', pageBreak: 'before' },
  ];
};